<template>
  <div>
  <v-card>
    <v-toolbar card  light dense flat>
      <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-scroll md flat :offset="calcOffset(52)">
      <v-stepper v-model="currentStep" vertical>
        <template v-for="step in steps">
          <v-stepper-step :complete="complete(step)" :step="step.number" editable>
            {{step.title}}
            <small v-if="step.subTitle">{{ typeof step.subTitle === "function" ? step.subTitle(step) : ''}}</small>
          </v-stepper-step>
          <v-stepper-content :step="step.number">
            <v-card flat>
              <v-card-text>
                <component
                   :is="step.class || 'v-step-generator'"
                   v-model=step.model
                   v-bind="step.props"
                   >
                </component>              
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="next(step)">Дальше</v-btn>
                <v-btn flat @click="back(step)">{{step.number > 1 ? 'Назад' : 'Отмена'}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </template>  
      </v-stepper>
    </v-card-scroll>  
    <v-card-actions>
      <v-btn @click="print('docx')">Составить</v-btn>
    </v-card-actions>

  </v-card>
  
</div>
</template>

<script type="text/javascript">
  import server from '../../api/server.js'
  import dialogs from '../common/dialogs'
  import { mapGetters } from 'vuex'
  import client from '../client'
  import vStepGenerator from './StepGenerator.vue'
  import ClaimSteps from './ClaimSteps.js'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'assist-claim',
    components: {vStepGenerator, vCardScroll},
    data: () => ({
      currentStep: 1,
      edit: false,
      valid: false,
      item: {},
      steps: [],
      mode: 'page'
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      // const rule = v => !!v || 'хаха'
      this.steps = ClaimSteps.createSteps(this)
      this.fetchData(this.itemId)
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
      }
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs',
        getNewAssistMatter: 'getNewAssistMatter',
        getDepoUrl: 'getDepoUrl'
      }),
      title () {
        return 'Претензия'
      }
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      next (step) {
        // var self = this
        this.currentStep = step.number + 1
        this.item.model.currentStep = this.currentStep
        this.$store.dispatch('updateAssistMatter', this.item).then(
          () => {
            this.fetchData(this.item.id)
          },
          () => {}
          )
      },
      back (step) {
        this.currentStep = step.number - 1
      },
      complete (step) {
        return this.currentStep > step.number
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      print (format) {
        let url = server.getBaseUrl() + '/openapi/assist/matters/' + this.item.id + '/reports_redirect?format=' + format
        this.$store.dispatch('openLocation', url)
      },
      getItemNew () {
        var defOps = {
          'agreement_topic_title1': 'В соответствии с п.1.1, 1.2 Договора от 03.03.2016 № М-448',
          'agreement_topic_content1': 'ООО "ПОСТАВЩИК" (Поставщик) приняло на себя обязательства в течение срока действия данного договора поставлять по заказу ООО "ДОЛЖНИК" (Покупателя) алкогольную продукцию российского и/или иностранного производства (Товар) в количестве, ассортименте и по цене, согласованным в Заявках Покупателя, а Покупатель принял на себя обязательства принимать и оплачивать Товар в соответствии с условиями этого Договора.',
          'agreement_topic_title2': 'Согласно п. 2.1 Договора от 14.12.2015 № М-429 (далее – Договор поставки)',
          'agreement_topic_content2': 'Поставщиком осуществляется доставка Товара по указанному в лицензии складу/магазину Покупателя.',
          'agreement_topic_title3': 'В соответствии с п. 2.2 Договора',
          'agreement_topic_content3': 'отпуск товара Покупателю оформляется товарно-транспортной накладной, один экземпляр которой остается у Поставщика, а другой - у Покупателя.',
          'agreement_topic_title4': 'В силу п. 2.4 Договора',
          'agreement_topic_content4': 'обязанности Поставщика по поставке Товара считаются исполненными с момента приёмки Товара Покупателем, что подтверждается подписанием Покупателем товарной накладной.',
          'agreement_topic_title5': 'Согласно п. 2.5 Договора',
          'agreement_topic_content5': 'право собственности на товар, риски утраты, недостачи или повреждения товара от Поставщика к Покупателю с момента приёмки Товара и подписания уполномоченными представителями Сторон накладной.'
        }
        var item = this.getNewAssistMatter()
        Object.assign(item.model, defOps)
        this.steps.forEach((step) => step.setModel(item.model))
        return item
      },
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('getAssistMatter', itemId).then(
            (item) => {
              this.item = item
              this.currentStep = this.item.model.currentStep
              this.steps.forEach((step) => step.setModel(this.item.model))
            },
            () => {})
        } else {
          console.log('fetchData', 'itemId == null')
          this.item = this.getItemNew()
        }
      },
      selectCompany (fieldName) {
        const setItem = (values) => {
          if (Array.isArray(values) && values.length > 0) {
            if (!values[0].ref || values[0].namespace === 'nza' || values[0].namespace === 'ogrnip') {
              dialogs.message(this, 'Совет', `Тип контрагента [${values[0].namespace}] не поддерживается `)
            } else {
              this.item.company = values[0]
              this.item.refCode = this.item.company.ref
              this.item.model.companyInn = this.item.company.inn
            }
          }
        }
        const getQuery = () => {}
        client.selectRef(this, setItem, getQuery, true, true)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// AssistClaim.vue?4db25548